import { useContext, useState, useEffect } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { CartContext } from '../../../features/cartContext/CartContext'
import { OrderContext } from "../../../features/cartContext/OrderContext"
import { stateNames } from '../../../constants/index'
import { toast } from "react-hot-toast";

// ???????????????????
import { useAddNewOrderMutation } from "./orderApiSlice"
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js"
import PaypalPayment from "./PaypalPayment"

function validateEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
}
function validatePhone(phone) {
    const phonePattern = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;
    var digits = phone.replace(/\D/g, "");
    return phonePattern.test(digits)
}

function phoneFormat(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match && validatePhone(phoneNumberString)) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
}

const CheckOut = () => {
   const location = useLocation();
    let totalPriceVal = location.state?.totalPriceVal;
    let shippingPriceVal = location.state ? location.state.shippingPrice : 0.0
    let taxEstimationVal = location.state ? location.state.taxEstimation : 0.0
    let subTotalVal = location.state ? location.state.subTotalVal : 0.0
    let tippingVal = location.state ? location.state.tipping : 0.0
    let groceryOrderType = location.state ? location.state.groceryOrderType : null
    let foodOrderType = location.state ? location.state.foodOrderType : null


    const [dataM, setDataM] = useState(null);

    const [{ isPending }] = usePayPalScriptReducer();
    // console.log(isPending);

    const [addNewOrder, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewOrderMutation()

    const [discount, setDiscount] = useState(0)

    const cart = useContext(CartContext)

    const navigate = useNavigate()

    const [orderInfo, setOrderInfo] = useState(
        {
            userInfo:
            {
                firstName: "",
                lastName: "",
                email: "",
                phone: ""
            },
            orders: cart.items,
            description: "",
            status: "",
            deliveryInfo:
            {
                deliveryType: location.state ? location.state.deliveryTypeVal : "regular",
                streetAdress: location.state ? (location.state.foodOrderType && !location.state.groceryOrderType) ? "2013 Wells Branch Pkwy" : "" : "",
                streetAdress_1: location.state ? (location.state.foodOrderType && !location.state.groceryOrderType) ? "2013" : "" : "",
                city: location.state ? (location.state.foodOrderType && !location.state.groceryOrderType) ? "Austin" : "" : "",
                state: location.state ? (location.state.foodOrderType && !location.state.groceryOrderType) ? "TX" : "" : "",
                zipCode: location.state ? (location.state.foodOrderType && !location.state.groceryOrderType) ? "78728" : "" : "",
                country: "USA"
            },
            approveId: {
                Id: "No order",
            },
            customerTips: tippingVal,
            taxEstimationVal: taxEstimationVal,
            totalPriceVal: totalPriceVal,
            reciveOrderStatus: false
        }
    );

    const handleFirstNameChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, userInfo: {
                ...prevInfo.userInfo, firstName: e.target.value
            }
        }));
    };

    const handleLastNameChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, userInfo: {
                ...prevInfo.userInfo, lastName: e.target.value
            }
        }));
    };

    const handlePhoneChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, userInfo: {
                ...prevInfo.userInfo, phone: e.target.value
            }
        }));
    };
    const handleEmailChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, userInfo: {
                ...prevInfo.userInfo, email: e.target.value
            }
        }));
    };

    const handleDeliveryStreetChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, deliveryInfo: {
                ...prevInfo.deliveryInfo, streetAdress: e.target.value
            }
        }));
    };
    const handleDeliveryStreet_1_Change = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, deliveryInfo: {
                ...prevInfo.deliveryInfo, streetAdress_1: e.target.value
            }
        }));
    };

    const handleDeliveryCityChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, deliveryInfo: {
                ...prevInfo.deliveryInfo, city: e.target.value
            }
        }));
    };

    const handleDeliveryStateChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, deliveryInfo: {
                ...prevInfo.deliveryInfo, state: e.target.value
            }
        }));
    };

    const handleDeliveryZipCodeChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, deliveryInfo: {
                ...prevInfo.deliveryInfo, zipCode: e.target.value
            }
        }));
    };

    const handleDeliveryCountryChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, deliveryInfo: {
                ...prevInfo.deliveryInfo, country: e.target.value
            }
        }));
    };

    const handlereciveOrderStatusChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, reciveOrderStatus: !prevInfo.reciveOrderStatus
        }));
    };

    const handleDescriptionChange = (e) => {
        setOrderInfo((prevInfo) => ({
            ...prevInfo, description: e.target.value
        }));
    };

    const canSave = [
        orderInfo.userInfo.firstName,
        orderInfo.userInfo.lastName,
        orderInfo.orders.length !== 0,
        orderInfo.deliveryInfo.deliveryType,
        orderInfo.deliveryInfo.streetAdress,
        orderInfo.deliveryInfo.city,
        orderInfo.deliveryInfo.state,
        orderInfo.deliveryInfo.zipCode,
        validateEmail(orderInfo.userInfo.email),
        validatePhone(orderInfo.userInfo.phone)
    ].every(Boolean) && !isLoading


    const onSaveOrderClicked = async () => {
       // const response = await addNewOrder({ approveId: orderInfo.approveId, userInfo: orderInfo.userInfo, orders: orderInfo.orders, deliveryInfo: orderInfo.deliveryInfo, reciveOrderStatus: orderInfo.reciveOrderStatus, description: orderInfo.description })

        const response = await addNewOrder({ approveId: orderInfo.approveId, userInfo: orderInfo.userInfo, orders: orderInfo.orders, deliveryInfo: orderInfo.deliveryInfo, reciveOrderStatus: orderInfo.reciveOrderStatus, description: orderInfo.description, customerTips: orderInfo.customerTips, taxEstimationVal: orderInfo.taxEstimationVal, totalPriceVal: orderInfo.totalPriceVal })
        
        console.log("====> this is response from backend----> ", response)


        return response ? true : false
    }

    useEffect(() => {

        if (orderInfo.approveId !== null && orderInfo.approveId !== "No order" && canSave) {
            try {
                if (onSaveOrderClicked()) {

                    toast("Payment successful!", {
                        icon: "🥳",
                        style: {
                            borderRadius: "5px",
                            background: "#333",
                            color: "#fff",
                        },
                    });

                    totalPriceVal = 0.0;
                    shippingPriceVal = 0.0
                    taxEstimationVal = 0.0
                    subTotalVal = 0.0
                    const temp = orderInfo.approveId
                    orderInfo.approveId = null
                    navigate('/OnlineOrdering/Approved',
                        { state: { confirmationNumber: temp } })
                }
            } catch (err) {
                console.log(" error for saving to database", err)
            }
            console.log("perfect")
        }

    }, [orderInfo.approveId]);


    useEffect(() => {
        if (dataM) {
            setOrderInfo((prevInfo) => ({
                ...prevInfo, approveId: dataM.id
            }))

        }

    }, [dataM]);

    let phoneFormatted = phoneFormat(orderInfo.userInfo.phone) // I can use this anywhere to display to the user

    // console.log(phoneFormatted)

    useEffect(() => {
        console.log("order info", orderInfo)
    }, [orderInfo]);

    const input__incomplete = "bg-gray-50 border border-red-800 text-red-600 text-sm  focus:ring-blue-500 duration-300 ease focus:outline-none focus:border-red-700 hover:border-red-700 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
    const input__complete = "bg-gray-50 border border-green-800 text-gray-600 text-sm  focus:ring-blue-500 duration-300 ease focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 focus:outline-none focus:border-green-700 hover:border-green-700"

    const validPhoneClass = !validatePhone(orderInfo.userInfo.phone) ? input__incomplete : input__complete
    const validEmailClass = !validateEmail(orderInfo.userInfo.email) ? input__incomplete : input__complete
    const validFirstNameClass = !orderInfo.userInfo.firstName ? input__incomplete : input__complete
    const validLastNameClass = !orderInfo.userInfo.lastName ? input__incomplete : input__complete

    const validStreetAdressClass = !orderInfo.deliveryInfo.streetAdress ? input__incomplete : input__complete
    const validCityClass = !orderInfo.deliveryInfo.city ? input__incomplete : input__complete
    const validStateClass = !orderInfo.deliveryInfo.state ? input__incomplete : input__complete
    const validzipCodeClass = !orderInfo.deliveryInfo.zipCode ? input__incomplete : input__complete
    const validDeliveryTypeClass = !orderInfo.deliveryInfo.deliveryType ? input__incomplete : input__complete

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    const content_mod = (
        <div className=" text-left bg-white w-full max-w-xl">
            <form className="bg-white w-full rounded px-1 pt-6 ">
                <div className="flex flex-wrap -mx-3 mb-6 ">
                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-first-name">
                            First Name
                        </label>
                        <input
                            // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="firstName"
                            type="text"
                            placeholder="First Name"
                            value={orderInfo.userInfo.firstName}
                            onChange={(e) => handleFirstNameChange(e)}
                            className={validFirstNameClass}
                        />
                        {/* <p className="text-red-500 text-xs italic">Please fill out this field.</p> */}
                    </div>
                    <div className="w-full md:w-1/2 px-3">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                            htmlFor="lastName">
                            Last Name
                        </label>
                        <input
                            // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="lastName"
                            type="text" placeholder="Last Name"
                            value={orderInfo.userInfo.lastName}
                            onChange={(e) => handleLastNameChange(e)}
                            className={validLastNameClass}
                        />
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block tracking-wide text-gray-800 text-sm font-bold mb-2"
                            htmlFor="streetAdress"
                        >
                            Address Line 1
                        </label>
                        <input
                            // className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-address-1" type="text"
                            placeholder="2013 Wells Branch Pkwy"
                            name="streetAdress"
                            autoComplete="off"
                            value={orderInfo.deliveryInfo.streetAdress}
                            onChange={(e) => handleDeliveryStreetChange(e)}
                            className={validStreetAdressClass}
                        />
                        {/* <p className="text-xs italic">Please enter your street address.</p> */}
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block tracking-wide text-gray-800 text-sm font-bold mb-2" htmlFor="grid-address-2">
                            Address Line 2
                        </label>
                        <input className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="streetAdress_1"
                            type="text"
                            placeholder="Suite ABC"
                            name="streetAdress_1"
                            autoComplete="off"
                            value={orderInfo.deliveryInfo.streetAdress_1}
                            onChange={(e) => handleDeliveryStreet_1_Change(e)}
                        />
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-2">
                    <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-city">
                            City
                        </label>
                        <div className="relative">
                            <input
                                // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                id="city"
                                type="text"
                                name="city"
                                value={orderInfo.deliveryInfo.city}
                                onChange={(e) => handleDeliveryCityChange(e)}
                                placeholder="Austin"
                                className={validCityClass}
                            />
                            {/* <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                            </div> */}
                        </div>

                    </div>
                    <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                            State
                        </label>
                        <div className="relative">
                            <select
                                className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                id="state"
                                name="state"
                                value={orderInfo.deliveryInfo.state}
                                onChange={(e) => handleDeliveryStateChange(e)}
                            // className={validStateClass}
                            >
                                {stateNames.map((val, idx) => (<option key={idx}>{val}</option>))}

                            </select>
                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-zip">
                            Zip
                        </label>
                        <input
                            // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="grid-zip"
                            type="text"
                            name="zipCode"
                            value={orderInfo.deliveryInfo.zipCode}
                            onChange={(e) => handleDeliveryZipCodeChange(e)}
                            placeholder="78728"
                            className={validzipCodeClass}

                        />
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block tracking-wide text-gray-800 text-sm font-bold mb-2" htmlFor="grid-phone">
                            Phone
                        </label>
                        <input
                            // className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="phone"
                            type="tel"
                            placeholder="+1-512-291-7281"
                            name="phone"
                            value={orderInfo.userInfo.phone}
                            onChange={(e) => handlePhoneChange(e)}
                            className={validPhoneClass}
                        />
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block tracking-wide text-gray-800 text-sm font-bold mb-2" htmlFor="grid-phone">
                            Email
                        </label>
                        <input
                            // className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="email"
                            type="text"
                            placeholder="megenagna@gmail.com"
                            name="email"
                            value={orderInfo.userInfo.email}
                            onChange={(e) => handleEmailChange(e)}
                            className={validEmailClass}
                        />
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your message</label>
                        <textarea
                            id="description"
                            rows="4"
                            className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Write your note here..."
                            name="description"
                            value={orderInfo.description}
                            onChange={(e) => handleDescriptionChange(e)}
                        />

                    </div>
                </div>
                <div className=" flex gap-6">
                    <div className="mb-6">
                        <label className="flex items-center text-gray-800 text-sm font-bold">
                            <input className="mr-2 leading-tight"
                                type="checkbox"
                                name="reciveOrderStatus"
                                value={orderInfo.userInfo.reciveOrderStatus}
                                onChange={(e) => handlereciveOrderStatusChange(e)}
                            />
                            <span className="text-sm">
                                Receive order status updates via text message
                            </span>
                        </label>
                    </div>
                </div>
            </form>
        </div>
    )

    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ from paypal page

    const content_mod_foodOrder = (
        <div className=" text-left bg-white w-full max-w-xl">
            <form className="bg-white w-full rounded px-1 pt-6 ">
                <div className="flex flex-wrap -mx-3 mb-6 ">
                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-first-name">
                            First Name
                        </label>
                        <input
                            // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="firstName"
                            type="text"
                            placeholder="First Name"
                            value={orderInfo.userInfo.firstName}
                            onChange={(e) => handleFirstNameChange(e)}
                            className={validFirstNameClass}
                        />
                        {/* <p className="text-red-500 text-xs italic">Please fill out this field.</p> */}
                    </div>
                    <div className="w-full md:w-1/2 px-3">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                            htmlFor="lastName">
                            Last Name
                        </label>
                        <input
                            // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="lastName"
                            type="text" placeholder="Last Name"
                            value={orderInfo.userInfo.lastName}
                            onChange={(e) => handleLastNameChange(e)}
                            className={validLastNameClass}
                        />
                    </div>
                </div>

                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block tracking-wide text-gray-800 text-sm font-bold mb-2" htmlFor="grid-phone">
                            Phone
                        </label>
                        <input
                            // className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="phone"
                            type="tel"
                            placeholder="+1-512-291-7281"
                            name="phone"
                            value={orderInfo.userInfo.phone}
                            onChange={(e) => handlePhoneChange(e)}
                            className={validPhoneClass}
                        />
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block tracking-wide text-gray-800 text-sm font-bold mb-2" htmlFor="grid-phone">
                            Email
                        </label>
                        <input
                            // className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="email"
                            type="text"
                            placeholder="megenagna@gmail.com"
                            name="email"
                            value={orderInfo.userInfo.email}
                            onChange={(e) => handleEmailChange(e)}
                            className={validEmailClass}
                        />
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your message</label>
                        <textarea
                            id="description"
                            rows="4"
                            className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Write your note here..."
                            name="description"
                            value={orderInfo.description}
                            onChange={(e) => handleDescriptionChange(e)}
                        />

                    </div>
                </div>
                <div className=" flex gap-6">
                    <div className="mb-6">
                        <label className="flex items-center text-gray-800 text-sm font-bold">
                            <input className="mr-2 leading-tight"
                                type="checkbox"
                                name="reciveOrderStatus"
                                value={orderInfo.userInfo.reciveOrderStatus}
                                onChange={(e) => handlereciveOrderStatusChange(e)}
                            />
                            <span className="text-sm">
                                Receive order status updates via text message
                            </span>
                        </label>
                    </div>
                </div>
            </form>
        </div>
    )




    // ____________________________________________________________________________________________
    const styles = {
        disableMaxWidth: true,
    };

   // const serverUrl = "http://localhost:4000";
    const serverUrl = "https://megenagnacafe-api.onrender.com";
    // ++++++++++++++++++++newly added test

    const displayOnly = ["vaultable"];

    const createOrder = async () => {

        try {
            const response = await fetch(`${serverUrl}/checkOut/create-paypal-order`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    product: {
                        description: orderInfo.description,
                        cost: parseFloat(totalPriceVal),
                    },
                }),
            });

            const orderData = await response.json();

            if (!orderData.id) {
                const errorDetail = orderData.details[0];
                const errorMessage = errorDetail
                    ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                    : "Unexpected error occurred, please try again.";

                throw new Error(errorMessage);
            }
            return orderData.id;

        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    const onApprove = (data) => {

        // return fetch(`${serverUrl}/checkOut/capture-paypal-order`, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify({
        //         orderID: data.orderID,
        //     }),
        // }).then((response) => {
        //     toast("Payment successful!", {
        //         icon: "🥳",
        //         style: {
        //             borderRadius: "5px",
        //             background: "#333",
        //             color: "#fff",
        //         },
        //     });
        //     return response.json();
        // }).then((json) => {
        //     // navigate('/OnlineOrdering/Approved',
        //     //     { state: { confirmationNumber: json.id } }
        //     // )
        //     console.log(json)
        //     return json.id
        // }).then((id) => {
        //     setOrderId(id);
        // }).catch((err) => {
        //     toast.error("Payment Failed!");
        //     return err
        // });


        const fetchData = async () => {
            try {
                const response = await fetch(`${serverUrl}/checkOut/capture-paypal-order`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        orderID: data.orderID,
                    }),
                })

                const jsonData = await response.json();
                setDataM(jsonData);
            } catch (error) {
                toast.error("Payment Failed!");
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    };


    const onCancel = (data) => {
        navigate('/OnlineOrdering/Cancel')
    }
    const onError = (err) => {
     navigate('/OnlineOrdering/Cancel')
    }
    const content_mod_final = (

        <div className=" block md:grid md:grid-cols-12 mx-4 my-10 ">

            <div className="col-span-7 mx-4 ">
                <div className="my-4">Shipping Address</div>
                {foodOrderType && !groceryOrderType ? content_mod_foodOrder : content_mod}
            </div>
            <div></div>

            <div className=" col-span-4">
                <div>
                    <div>
                        <div className="mt-6 grow sm:mt-8 lg:mt-0 ">
                            <div className="space-y-4 rounded-lg border border-gray-100 bg-gray-50  p-6 dark:border-gray-700 dark:bg-gray-800">
                                <div className="space-y-2">
                                    <dl className="flex items-center justify-between gap-4">
                                        <dt className="text-base font-normal text-gray-500 dark:text-gray-400">Original price</dt>
                                        <dd className="text-base font-medium text-gray-900 dark:text-white">
                                            {/* $6,592.00 */}
                                            <p className="text-gray-700">
                                                $
                                                {
                                                    subTotalVal
                                                }</p>
                                        </dd>
                                    </dl>
                                    <dl className="flex items-center justify-between gap-4">
                                        <dt className="text-base font-normal text-gray-500 dark:text-gray-400">Savings</dt>
                                        <dd className="text-base font-medium text-green-500">-$0.00</dd>
                                    </dl>

                                    <dl className="flex items-center justify-between gap-4">
                                        <dt className="text-base font-normal text-gray-500 dark:text-gray-400">Store Pickup</dt>
                                        <dd className="text-base font-medium text-gray-900 dark:text-white">
                                            {/* $6,592.00 */}
                                            <p className="text-gray-700">
                                                $
                                                {
                                                    totalPriceVal
                                                }

                                            </p>
                                        </dd>
                                    </dl>

                                    <dl className="flex items-center justify-between gap-4">
                                        <dt className="text-base font-normal text-gray-500 dark:text-gray-400">Shipping </dt>
                                        <dd className="text-base font-medium text-gray-900 dark:text-white">
                                            {/* $6,592.00 */}
                                            <p className="text-gray-700">
                                                $
                                                {
                                                    shippingPriceVal
                                                }
                                            </p>
                                        </dd>
                                    </dl>
                                    <dl className="flex items-center justify-between gap-4">
                                        <dt className="text-base font-normal text-gray-500 dark:text-gray-400">Tax estimate</dt>
                                        <dd className="text-base font-medium text-gray-900 dark:text-white">
                                            {/* $6,592.00 */}
                                            <p className="text-gray-700">
                                                $
                                                {
                                                    taxEstimationVal
                                                }
                                            </p>
                                        </dd>
                                    </dl>
                                    <dl className="flex items-center justify-between gap-4">
                                        <dt className="text-base font-normal text-gray-500 dark:text-gray-400">Tips </dt>
                                        <dd className="text-base font-medium text-gray-900 dark:text-white">
                                            {/* $6,592.00 */}
                                            <p className="text-gray-700">
                                                $
                                                {
                                                    tippingVal
                                                    // (parseFloat(totalPriceVal) - parseFloat(subTotalVal) - parseFloat(shippingPriceVal) - parseFloat(taxEstimationVal)).toFixed(2)
                                                }
                                            </p>
                                        </dd>
                                    </dl>


                                                
                                </div>

                                <div className="flex items-center justify-between gap-4 border-t border-gray-200 pt-2 dark:border-gray-700">
                                    <div className="text-base font-bold text-gray-900 dark:text-white">Total</div>
                                    <div className="text-base font-bold text-gray-900 dark:text-white">                                        {/* 7,191.00 */}
                                        <dd className="text-base font-medium text-gray-900 dark:text-white">
                                            {/* $6,592.00 */}
                                            <p className="text-gray-700">
                                                $

                                                {totalPriceVal}

                                            </p>
                                        </dd>
                                    </div>
                                </div>
                            </div>

                            {isPending ? <div>Loading...</div> :
                                 <button className=" w-[80%] fle justify-between mx-auto">
                                  <PayPalButtons 
                                         fundingSource="paypal"
                                         style={{
                                            layout: 'horizontal',
                                            color: 'blue',
                                            shape: 'rect',
                                            label: 'paypal',
                                            height: 35,
                                            disableMaxWidth: true
                                        }}
                                     createOrder={(data, actions) => createOrder(data, actions)}
                                     onApprove={(data, actions) => onApprove(data, actions)}
                                     onCancel={(data, actions) => onCancel(data, actions)}
                                     onError={(data, actions) => onError(data, actions)}
                                     disabled={canSave ? false : true}
                                     />
                                </button>

                                

}
                        </div>
                    </div>
                    <p className="mt-6 text-center text-gray-500 dark:text-gray-400 sm:mt-8 lg:text-left">
                        Payment processed by <a href="https://www.paypal.com" title="" className="font-medium text-primary-700 underline hover:no-underline dark:text-primary-500">Paypal</a>
                        - United States Of America
                    </p>
                </div>
            </div>
        </div >

    )

    return content_mod_final
}

export default CheckOut
